import { render, staticRenderFns } from "./ServiceCompensationTabServiceRp.vue?vue&type=template&id=98b5cf3e&scoped=true"
import script from "./ServiceCompensationTabServiceRp.vue?vue&type=script&lang=js"
export * from "./ServiceCompensationTabServiceRp.vue?vue&type=script&lang=js"
import style0 from "./ServiceCompensationTabServiceRp.vue?vue&type=style&index=0&id=98b5cf3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b5cf3e",
  null
  
)

export default component.exports